import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Side-effect import: registers the global axios request interceptor that
// auto-injects X-Bonsai-User-Id on every outbound request. Must run before App
// mounts so the very first dashboard fetches carry the session header.
import "./config/api";
// Side-effect import: installs the canonical user-facing error formatter on
// window.errorMessage (ERRSWEEP, 30Jun2026). The codebase has ~40 call sites
// guarded with `typeof window.errorMessage === "function"`; installing it here
// before App mounts upgrades all of them off the bare axios
// "Request failed with status code N" string in one place.
import "./utils/errorMessage";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
